
import {createSlice} from '@reduxjs/toolkit'
import { fetchWorkorderStatus } from '../../action/master/WorkorderStatusAction'

interface WorkorderStatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: WorkorderStatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const WorkorderStatusSlice = createSlice({
  name: 'WorkorderStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkorderStatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchWorkorderStatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchWorkorderStatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default WorkorderStatusSlice.reducer
